<article class="solution-option" [class.seleccionada]="seleccionada()" [class.actual]="esLaActual()"
  [class.sin-destino]="sinDestino()" (click)="alElegir()" (keydown.enter)="alElegir()"
  (keydown.space)="alElegir(); $event.preventDefault()" role="button" tabindex="0"
  [attr.aria-pressed]="seleccionada()">

  <div class="solution-info">
    <div class="solution-logo" aria-hidden="true">
      @if (solucion().imagenUrl) {
      <img [src]="solucion().imagenUrl" [alt]="solucion().nombre">
      } @else {
      <span>{{ inicial() }}</span>
      }
    </div>

    <div class="solution-texts">
      <h3 class="solution-name title-medium">{{ solucion().nombre }}</h3>
      @if (esLaActual()) {
      <span class="solution-badge label-medium">{{ 'Estás aquí' | translate }}</span>
      } @else if (sinDestino()) {
      <span class="solution-badge label-medium">{{ 'Sin dirección todavía' | translate }}</span>
      }
    </div>
  </div>

  <mat-icon class="selection-indicator" [class.visible]="seleccionada()" aria-hidden="true">
    chevron_right
  </mat-icon>
</article>
